import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/Home";
Vue.use(Router);
export default new Router({
  // mode: "history",
  // base: '/jisao/',
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "首页"
      }
    },
    {
      path: "/saluteheroes",
      name: "saluteheroes",
      component: () => {
        return import("@/pages/saluteheroes/index");
      }
    },
    {
      path: "/sunword",
      name: "sunword",
      component: () => {
        return import("@/pages/sunword/index");
      }
    },
    {
      path: "/searchheros",
      name: "searchheros",
      component: () => {
        return import("@/pages/searchheros/index");
      }
    },
    {
      path: "/yingxunjidian/index.html",
      name: "permartyrs",
      component: () => {
        return import("@/pages/permartyrs/index");
      }
    },
    {
      path: "/sacrificeRight",
      name: "sacrificeRight",
      component: () => {
        return import("@/pages/permartyrs/components/sacrificeRight/index");
      }
    },
    {
      path: "/nodatas",
      name: "nodatas",
      component: () => {
        return import("@/pages/permartyrs/components/sacrificeRight/nodatas");
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js